import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useLocalStorageChangeEffect } from '@leanpay/hooks'
import { storage } from '@leanpay/local-storage'
import { LoadingIndicator } from '@leanpay/ui'
import { STORAGE_KEY } from '@leanpay/utils'

import AppContext from './app-context'
import { useGetSessionInfo } from 'library/utils/query-hooks'

const AppStore = ({ children }: { children: ReactNode }) => {
    const location = useLocation()
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    const [verificationCode, setVerificationCode] = useState<string>('')
    const [phoneNumber, setPhoneNumber] = useState<string>('')
    const [progress, setProgress] = useState<number>(10)

    const { data: sessionInfo, isPending } = useGetSessionInfo()

    const resetState = () => {
        setVerificationCode('')
        setPhoneNumber('')
        setProgress(10)
        setIsAuthenticated(false)
    }

    useLocalStorageChangeEffect(() => {
        if (!storage.load(STORAGE_KEY.SESSION_INFO) && location.pathname !== '/login') {
            resetState()
        }
    })

    useEffect(() => {
        if (!sessionInfo?.phoneNumber) return
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Synchronizing authentication state with session info
        setIsAuthenticated(true)
    }, [sessionInfo])

    if (isPending) {
        return (
            <div className="flex flex-1 items-center flex-col justify-center">
                <LoadingIndicator loadingMessage="" />
            </div>
        )
    }
    return (
        <AppContext.Provider
            value={{
                progress,
                setProgress,
                verificationCode,
                setVerificationCode,
                isAuthenticated,
                setIsAuthenticated,
                phoneNumber,
                setPhoneNumber,
            }}
        >
            {children}
        </AppContext.Provider>
    )
}

export default AppStore
